class CanadianHomesSection extends HTMLElement {
  constructor() {
    super();
    this.randomNum = Math.round(Math.random() * 10000);

    this.swiperEl = this.querySelector(".chs__swiper-container");
    this._initSwiper = this._initSwiper.bind(this);
    this._sectionrenderLogic();
    this._addEventListeners();
    this.slides = this.querySelectorAll(".swiper-slide");
    this.arrowsInitialized = false;
  }

  _sectionrenderLogic() {
    if (!this.swiperEl) return;

    const initSwiper = () => {
      const isAboveFold = this.getBoundingClientRect().top < window.innerHeight;

      if (isAboveFold) {
        window.swiperLoader.initImmediately(this._initSwiper);
      } else {
        const viewportHeight = window.innerHeight;
        window.swiperLoader.initWhenVisible(this, this._initSwiper, {
          rootMargin: `${viewportHeight}px`,
          threshold: 0.1,
        });
      }
    };

    if (window.swiperLoader) {
      initSwiper();
    } else {
      window.addEventListener("swiperloader:ready", initSwiper, { once: true });
    }

    window.addEventListener("resize", () => {
      if (this.swiper && window.Swiper) {
        this._initSwiper(window.Swiper);
      }
    });
  }
  _hideSection() {
    this.ariaHidden = "true";
  }
  _showSection() {
    this.ariaHidden = "false";
  }
  _setEqualHeight() {
    let maxHeight = 0;

    // Reset heights to 'auto' to recalculate
    this.slides.forEach((slide) => {
      slide.style.height = "auto";
    });

    // Find the tallest slide
    this.slides.forEach((slide) => {
      if (slide.offsetHeight > maxHeight) {
        maxHeight = slide.offsetHeight;
      }
    });

    // add it as a CSS variable for this element
    this.style.setProperty("--max-height", `${maxHeight}px`);
  }

  // Method to add event listeners for window load and resize
  _addEventListeners() {
    window.addEventListener("load", () => this._setEqualHeight());
    window.addEventListener("resize", () => this._setEqualHeight());
  }
  _initSwiper(Swiper) {
    if (!Swiper) return;

    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
      this.arrowsInitialized = false;
    }

    this._setEqualHeight();
    const swiperId = "chs__swiper-container-" + this.randomNum;

    let arrowLeft = this.querySelector(".swiper-button-prev");
    let arrowRight = this.querySelector(".swiper-button-next");

    if (window.screen.availWidth < 990) {
      arrowLeft = this.querySelector(".large-up-hide .swiper-button-prev");
      arrowRight = this.querySelector(".large-up-hide .swiper-button-next");
    }

    if (!arrowLeft || !arrowRight) return;

    if (!this.arrowsInitialized) {
      arrowLeft.classList.add(`${swiperId}-arrow-left`);
      arrowRight.classList.add(`${swiperId}-arrow-right`);
      this.arrowsInitialized = true;
    }
    this.swiperEl.classList.add(swiperId);
    const config = {
      slidesPerView: 1,
      centeredSlides: true,
      loop: false,
      autoHeight: false,
      spaceBetween: 0,
      navigation: {
        prevEl: `.${swiperId}-arrow-left`,
        nextEl: `.${swiperId}-arrow-right`,
      },
      breakpoints: {
        769: {
          slidesPerView: "auto",
          loop: false,
          centeredSlides: false,
          autoHeight: false,
          spaceBetween: 32,
        },
        1400: {
          slidesPerView: "auto",
          loop: true,
          centeredSlides: false,
          autoHeight: false,
          spaceBetween: 32,
        },
      },
    };

    this.swiper = new Swiper(`.${swiperId}`, config);

    // let minHeight = 0;
    // let minImgHeight = 0;
    // const slides = this.swiperEl.querySelectorAll(".swiper-slide");
    // slides.forEach((slide) => {
    //   const computedStyle = window.getComputedStyle(slide);
    //   const heightWithoutPadding =
    //     slide.clientHeight -
    //     parseFloat(computedStyle.paddingTop) -
    //     parseFloat(computedStyle.paddingBottom);
    //   if (heightWithoutPadding > minHeight) minHeight = heightWithoutPadding;
    //   const imgHeight = slide.querySelector("img")?.offsetHeight || 0;
    //   if (imgHeight > minImgHeight) minImgHeight = imgHeight;
    // });
    // slides.forEach((slide) => {
    //   slide.style.minHeight = minHeight + "px";
    //   const img = slide.querySelector("img");
    //   if (img) {
    //     img.style.minHeight = minImgHeight + "px";
    //   }
    // });
    this._showSection();
  }
}

customElements.define("canadian-homes-section", CanadianHomesSection);
